<template>
  <div class="cw-object-popup" :style="{ top: y, left: x}" v-if="object">
    <div class="object-info">
      <h1 class="object-title">{{object.number}}</h1>
      <table class="cw-object-popup-table object-info-table">
        <tr>
          <th>Antal rum</th>
          <td>{{object.data['rooms']}}</td>
        </tr>
        <tr>
          <th>Storlek</th>
          <td>{{object.data['living_area']}} m<sup>2</sup></td>
        </tr>
        <tr v-if="object.data['floor_number']">
          <th>Våning</th>
          <td>{{object.data['floor_number']}}</td>
        </tr>
        <tr v-if="object.data['price']">
          <th>Pris</th>
          <td>{{object.data['price'].formatted}}</td>
        </tr>
        <tr v-if="object.data['monthly_fee']">
          <th>Avgift</th>
          <td>{{object.data['monthly_fee'].formatted}}</td>
        </tr>
        <tr>
          <th>Status</th>
          <td><span class="status-" :class="'status-'+object.status">{{object.status_name}}</span></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  // import {mapGetters} from 'vuex'

  export default {
    name: 'ObjectPopup',
    props: ['object', 'position'],
    data () {
      return {}
    },
    computed: {
      x () {
        return (this.position.x + 20) + 'px'
      },
      y () {
        return (this.position.y + 20) + 'px'
      }
    },
    created () {
    },
    mounted () {
    },
    methods: {},
    components: {}
  }
</script>
<style lang="scss">
  .cw-object-popup {
    z-index: 990;
    position: absolute;
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/ObjectPopup.vue